import { RoundButton } from '@cian/ui-kit/button';
import {
  IconChevronLeft16,
  IconChevronRight16,
  IconCianLogo24,
  IconDocumentsVerified24,
  IconVasPremium16,
} from '@cian/ui-kit/icons';
import { FC, ReactNode, useCallback, useRef } from 'react';

import card1Img from '../assets/card-1.png';
import card2Img from '../assets/card-2.png';
import card3Img from '../assets/card-3.png';
import style from './Features.css';

interface IFeatureCard {
  key: string;
  icon: ReactNode;
  image: string;
  title: ReactNode;
  description: string;
}

const CARDS: IFeatureCard[] = [
  {
    key: 'status',
    icon: <IconCianLogo24 color="brand-cornflowerblue" />,
    image: card1Img,
    title: (
      <>
        Эксклюзивный
        <br />
        статус
      </>
    ),
    description: 'Гости доверяют Суперхозяевам — такие объявления добавляют в избранное на 90% чаще',
  },
  {
    key: 'promotion',
    icon: <IconVasPremium16 color="brand-cornflowerblue" />,
    image: card2Img,
    title: (
      <>
        Усиленное
        <br />
        продвижение
      </>
    ),
    description: 'Способ выделиться в поиске и получить больше броней с новыми значками',
  },
  {
    key: 'sticker',
    icon: <IconDocumentsVerified24 color="brand-cornflowerblue" />,
    image: card3Img,
    title: (
      <>
        Оригинальная
        <br />
        наклейка
      </>
    ),
    description: 'Знак качества, который вы сможете разместить в интерьере объекта',
  },
];

export const Features: FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const scroll = useCallback((direction: 'left' | 'right') => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    const firstCard = container.firstElementChild as HTMLElement | null;

    if (!firstCard) {
      return;
    }

    const scrollAmount = firstCard.offsetWidth + 16;

    container.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
  }, []);

  return (
    <section className={style['features']}>
      <div className={style['inner']}>
        <div className={style['pagination']}>
          <RoundButton
            theme="fill_light"
            size="M"
            title="Назад"
            icon={<IconChevronLeft16 />}
            onClick={() => scroll('left')}
          />
          <RoundButton
            theme="fill_light"
            size="M"
            title="Вперёд"
            icon={<IconChevronRight16 />}
            onClick={() => scroll('right')}
          />
        </div>
        <div ref={containerRef} className={style['container']}>
          {CARDS.map(card => (
            <div key={card.key} className={style['card']}>
              <div
                className={style['card-header']}
                style={{ '--card-bg': `url(${card.image})` } as React.CSSProperties}
              >
                <div className={style['icon-container']}>{card.icon}</div>
              </div>
              <div className={style['card-content']}>
                <p className={style['card-title']}>{card.title}</p>
                <p className={style['card-description']}>{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
